"use client";

import dynamic from "next/dynamic";
import { useState, useEffect } from "react";
import { useMemo } from "react";
import { getMarkers } from "@/utils/dynamic-icons";
import { trackPinClick } from "@/utils/mixpanel";

const LeafletMap = dynamic(() => import("./LeafletMap"), { ssr: false });

export const GlutenFreeLeafletMap = ({
	deviceType,
	isActive,
	places = [],
	activePlace,
	setActivePlace,
}) => {
	const [shouldShowTooltip, setShouldShowTooltip] = useState(false);
	const markers = useMemo(() => getMarkers(), []);
	const [isFitBoundsBySteps, setIsFitBoundsBySteps] = useState(true);

	useEffect(() => {
		setTimeout(() => {
			setIsFitBoundsBySteps(false);
		}, 500);
	}, []);

	if (deviceType !== "desktop" || !isActive || places.length === 0) {
		return null;
	}

	return (
		<div className="h-screen w-[calc(100%-790px)] top-0 right-0 z-10 fixed overflow-hidden">
			<LeafletMap
				// FIXME: dynamically load in markers (remove isActive)
				// FIXME: there are issues with leaflet map events and next 14

				withMapEvents
				disableZoomEvents
				isFitBoundsBySteps={isFitBoundsBySteps}
				scrollWheelZoom
				steps={places.length > 0 ? places : [{ lat: 0, lon: 0 }]}
				markers={markers}
				isClusterMap={shouldShowTooltip}
				showAllTooltips={shouldShowTooltip}
				enforceStaticMap={deviceType === "mobile"}
				center={[places[0]?.lat || 0, places[0]?.lon || 0]}
				selectedStepsIds={activePlace ? [activePlace?._id] : [places[0]?._id]}
				flyToPosition={
					activePlace ? [activePlace?.lat, activePlace?.lon] : null
				}
				onZoomEnd={({ e: event, bounds }) => {
					const newZoomLevel = event.target._zoom;

					const visible = places.filter((marker) => {
						return bounds.contains([marker.lat, marker.lon]);
					});

					setShouldShowTooltip(newZoomLevel > 14 || visible.length <= 7);
				}}
				onClickStep={(place) => {
					trackPinClick();
					const stepElement = document.getElementById(
						`topten_stepElement_${place._id}`
					);
					if (stepElement) {
						stepElement.scrollIntoView({ behavior: "smooth" });
					}
					setActivePlace(place);
				}}
			/>
		</div>
	);
};
